/* eslint-disable */
import backbone from 'backbone';
import _ from 'underscore';
import $ from 'jquery';
var decorate = function (view, toggleOptions) {
  var decoratedView;
  decoratedView = view.extend({
    initialize: function (options) {
      this.options = options || ({});
      _applyIfExists(view.prototype.initialize, this, arguments);
    },
    render: function () {
      this.show();
      _applyIfExists(view.prototype.render, this, arguments);
      this.$container.html(this.$el);
      return this;
    },
    show: function () {
      if (!this.injected) {
        this.$container = $('<div/>').attr('class', toggleOptions.containerCss);
        this.$toggleEl = toggleOptions.getToggleEl();
      }
      this.$toggleEl.hide();
      if (!this.injected) {
        this.$toggleEl.after(this.$container);
        this.injected = true;
      } else {
        this.$container.show();
      }
      return this;
    },
    hide: function () {
      if (!!this.$container) {
        this.$container.hide();
      }
      if (!!this.$toggleEl) {
        this.$toggleEl.show();
      }
      return this;
    },
    remove: function () {
      this.hide();
      _applyIfExists(view.prototype.remove, this, arguments);
      if (!!this.$container) {
        this.$container.remove();
      }
      return this;
    }
  });
  function _applyIfExists(func, context, args) {
    if (_.isFunction(func)) {
      func.apply(context, _.toArray(args));
    }
  }
  return decoratedView;
};
export default {
  decorate: decorate
};

